import { ConfirmParams } from 'shared/dialogs/ConfirmDialog';
import { STATE_MANAGER } from 'shared/dialogs/state';

/**
 * Destroy all dialogs currently being shown
 * (For unit test cleanup mostly)
 */
export function reset() {
    STATE_MANAGER.reset();
}

/**
 * Create a confirmation dialog
 * @param props
 */
export function confirm(props: ConfirmParams) {
    STATE_MANAGER.instanceState = [
        ...STATE_MANAGER.instanceState,
        props,
    ];
}
